export default "__VITE_ASSET__05339456__"